import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import { Alert } from './styles';

const AlertAviso = ({ messageErrors, setAlertMessageErrors }) => {
  const handleShow = () => {
    messageErrors.forEach(({ fixed }, index) => {
      if (!fixed) {
        setTimeout(() => {
          setAlertMessageErrors(state => [
            ...state.filter((_, idx) => idx !== index),
          ]);
        }, 3000);
      }
    });
  };

  useEffect(() => {
    handleShow();
  }, [messageErrors]);

  return (
    <>
      {messageErrors.map(({ key, message }) => (
        <Alert key={key} message={message} type="warning" showIcon={true} />
      ))}
    </>
  );
};

AlertAviso.propTypes = {
  messageErrors: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      message: PropTypes.string,
      fixed: PropTypes.bool,
    })
  ),
  setAlertMessageErrors: PropTypes.func.isRequired,
};

AlertAviso.defaultProps = {
  messageErrors: [],
};

export default AlertAviso;
